// @ts-nocheck
import React from 'react';
import EventManagementInventory from '@/pages/admin/event-management/EventManagementInventory';

const DemoInventory: React.FC = () => {
  return <EventManagementInventory />;
};

export default DemoInventory;
